import { formatDate } from './DateHelper';
import DispatchIcon from '../components/common/icons/color/icr_envio.svg';
import ProductColorIcon from '../components/common/icons/color/icr_Preparando_pedido.svg';
import CancelPurchaseIcon from '../components/common/icons/color/icr_terminos_condiciones.svg';
import BuildColorIcon from '../components/common/icons/color/icr_Armado.svg';
import RipleyComIcon from '../components/common/icons/color/icr_ripleycom.svg';
import GiftcardIcon from '../components/common/icons/color/icr_giftcard.svg';
import ArcoLawIcon from '../components/common/icons/color/icr_notificaciones.svg';
import { ISSUES } from '../constants/issues';

import {
  NOT_RECEIVED_PRODUCT,
  AUTHORIZE_THIRD,
  CHANGE_ADDRESS,
  CHANGE_DATE,
  BAD_STATE_PRODUCT,
  GOLD_DISPATCH_CHARGE,
  INCOMPLETE_PRODUCT,
  NOT_WORKING_PRODUCT,
  CHANGE_PRODUCT,
  OTHER_PRODUCT,
  ASSEMBLE_PRODUCT,
  PRODUCT_WITH_ALARM,
  CANCEL_PURCHASE,
  STATUS_CANCEL_PURCHASE,
  REVERSE_OUT_OF_TIME,
  PROBLEMS_GIFTCARD,
  RPHONE,
  DEBIT,
  PROVIDERS,
  EXTEND_VALIDITY,
  CHANGE_PASS_RIPLEY_COM,
  CHANGE_EMAIL,
  ARCO_LAW_INFO,
} from '../constants/routes';
import { getProductType, isMkp } from './tickets/ticket.helper';

export const makeInitialState = (dataArrray) => {
  const mappedData = dataArrray.map((data) => ({
    [data.name]: {
      value: data?.value || '',
      error: false,
      message: false,
      helper: data.helper,
      inputAdornment: data.inputAdornment,
      label: data.label,
      success: data?.value ? true : false,
      textArea: data.textArea,
      rows: data.rows,
      multiline: data.multiline,
      disabled: data.disabled,
      required: data.required,
      hidden: data.hidden,
      disableFuture: data.disableFuture,
      disablePast: data.disablePast,
      info: data.info,
    },
  }));
  return mappedData.reduce((acc, curr) => {
    return { ...acc, ...curr };
  });
};

export const successesCounterInState = (innerState, validLength) => {
  let successes = 0;
  const successesToReach = validLength
    ? validLength
    : Object.keys(innerState).length;
  Object.keys(innerState).forEach((input) => {
    if (innerState[input].success || !innerState[input].required)
      successes += 1;
  });
  if (successes === successesToReach) return true;
  return false;
};

export const dispatchBodyGenerator = (innerState, name, validationBody) => {
  const { newValue, error, errorMessage, helperText } = validationBody;
  return {
    field: name,
    value: {
      value: newValue,
      error: error !== undefined ? error : innerState[name].error,
      message: errorMessage || innerState[name.message],
      helper: helperText !== undefined ? helperText : innerState[name].helper,
      inputAdornment: innerState[name].inputAdornment,
      label: innerState[name].label,
      success: error !== undefined ? !error : innerState[name].success,
      textArea: innerState[name].textArea,
      rows: innerState[name].rows,
      multiline: innerState[name].multiline,
      disabled: innerState[name].disabled,
      required: innerState[name].required,
    },
  };
};

export const formValidate = (data, state, schema, dispatch) => {
  const { name, value: newValue } = data;
  const errorValidation = schema.validate({ [name]: newValue });
  const error = 'error' in errorValidation;
  if (error) {
    const errorMessage = errorValidation.error.message;
    const bodyToCheck = { newValue, error, errorMessage };
    const dispatchBody = dispatchBodyGenerator(state, name, bodyToCheck);
    dispatch(dispatchBody);
  } else {
    const bodyToCheck = { newValue, error };
    const dispatchBody = dispatchBodyGenerator(state, name, bodyToCheck);
    dispatch(dispatchBody);
  }
};

export const defineCommentHelper = (name, newValue) =>
  name === 'comment' ? `${newValue.length}/250` : '';

export const numberValidation = (phone) => (phone ? /^\d+$/.test(phone) : '');

export const textMapper = new Map([
  [
    '2',
    {
      title: 'Despacho y retiro',
      subtitle: 'No ha llegado mi producto',
      redirect: NOT_RECEIVED_PRODUCT,
      icon: DispatchIcon,
    },
  ],
  [
    '29',
    {
      title: 'Despacho y retiro',
      subtitle: 'Cobro despacho Gold/Silver',
      redirect: GOLD_DISPATCH_CHARGE,
      icon: DispatchIcon,
    },
  ],
  [
    '22',
    {
      title: 'Gift Cards',
      subtitle: 'Consultar saldo Gift Card',
      icon: GiftcardIcon,
    },
  ],
  [
    '27',
    {
      title: 'Compras en ripley.com',
      subtitle: 'Cambio de contraseña Ripley.com',
      icon: RipleyComIcon,
      redirect: CHANGE_PASS_RIPLEY_COM,
    },
  ],
  [
    '26',
    {
      title: 'Compras en ripley.com',
      subtitle: 'Cambio de correo electrónico Ripley.com',
      icon: RipleyComIcon,
      redirect: CHANGE_EMAIL,
    },
  ],
  [
    '18',
    {
      title: 'Compras en ripley.com',
      subtitle: 'Copia de boleta o factura',
      icon: RipleyComIcon,
    },
  ],
  [
    '17',
    {
      title: 'Compras en ripley.com',
      subtitle: 'Inconveniente al momento de comprar',
      icon: RipleyComIcon,
    },
  ],
  [
    '33',
    {
      title: 'Compras en ripley.com',
      subtitle: 'Error en la página',
      icon: RipleyComIcon,
    },
  ],
  [
    '43',
    {
      title: 'Compras en ripley.com',
      subtitle: 'No recibir publicidad de Ripley',
      icon: RipleyComIcon,
    },
  ],
  [
    '28',
    {
      title: 'Despacho y retiro',
      subtitle: 'Autorizar a un tercero a retirar mi producto',
      redirect: AUTHORIZE_THIRD,
      icon: DispatchIcon,
    },
  ],
  [
    '10',
    {
      title: 'Despacho y retiro',
      subtitle: 'Cambiar dirección de despacho',
      redirect: CHANGE_ADDRESS,
      icon: DispatchIcon,
    },
  ],
  [
    '1',
    {
      title: 'Despacho y retiro',
      subtitle: 'Cambiar fecha de despacho',
      redirect: CHANGE_DATE,
      icon: DispatchIcon,
    },
  ],
  [
    '6',
    {
      title: 'Productos',
      subtitle: 'Llegó en mal estado',
      redirect: BAD_STATE_PRODUCT,
      icon: ProductColorIcon,
    },
  ],
  [
    '4',
    {
      title: 'Productos',
      subtitle: 'Llegó incompleto',
      redirect: INCOMPLETE_PRODUCT,
      icon: ProductColorIcon,
    },
  ],
  [
    '5',
    {
      title: 'Productos',
      subtitle: 'No funciona',
      redirect: NOT_WORKING_PRODUCT,
      icon: ProductColorIcon,
    },
  ],
  [
    '35',
    {
      title: 'Productos',
      subtitle: 'Cambio producto',
      redirect: CHANGE_PRODUCT,
      icon: ProductColorIcon,
    },
  ],
  [
    '3',
    {
      title: 'Productos',
      subtitle: 'Llegó otro producto',
      redirect: OTHER_PRODUCT,
      icon: ProductColorIcon,
    },
  ],
  [
    '9',
    {
      title: 'Armar Producto',
      subtitle: 'Armar Producto',
      redirect: ASSEMBLE_PRODUCT,
      icon: BuildColorIcon,
    },
  ],
  [
    '7',
    {
      title: 'Anular Compra',
      subtitle: 'Anular Compra',
      redirect: CANCEL_PURCHASE,
      icon: CancelPurchaseIcon,
    },
  ],
  [
    '11',
    {
      title: 'Anular Compra',
      subtitle: 'Ver estado de anulación de compra',
      redirect: STATUS_CANCEL_PURCHASE,
      icon: CancelPurchaseIcon,
    },
  ],
  [
    '44',
    {
      title: 'Anular Compra',
      subtitle: 'Reversa fuera de plazo',
      redirect: REVERSE_OUT_OF_TIME,
      icon: CancelPurchaseIcon,
    },
  ],
  [
    '37',
    {
      title: 'Productos',
      subtitle: 'Producto llegó con alarma',
      redirect: PRODUCT_WITH_ALARM,
      icon: ProductColorIcon,
    },
  ],
  [
    '31',
    {
      title: 'Gift Card',
      subtitle: 'Extender vigencia Gift Card',
      icon: GiftcardIcon,
      redirect: EXTEND_VALIDITY,
    },
  ],
  [
    '36',
    {
      title: 'Gift Card',
      subtitle: 'Inconveniente con mi Gift Card',
      icon: GiftcardIcon,
      redirect: PROBLEMS_GIFTCARD,
    },
  ],
  [
    '45',
    {
      icon: ArcoLawIcon,
      title: 'Derechos ARCO',
      subtitle: 'Ejercicios de derechos ARCO',
      redirect: ARCO_LAW_INFO,
    },
  ],
]);

export const concatenateComment = (motiveId, innerState) => {
  switch (motiveId) {
    case '31':
      return (
        'Giftcard: ' +
        (innerState?.giftCardNumber?.value || '') +
        ' - Comentario: ' +
        (innerState?.comment?.value || '')
      );
    case '36':
      return (
        'Giftcard: ' +
        (innerState?.giftCardNumber?.value || '') +
        ' Motivo reclamo: ' +
        (innerState?.problemsGiftcard?.value || '') +
        ' - Comentario: ' +
        (innerState?.comment?.value || '')
      );
    default:
      return innerState?.comment?.value || '';
  }
};

const setProductTypeFromProductSku = (data) => {
  const product = {
    isMkp: false,
    oc: data,
  };
  product.isMkp = isMkp(product.oc);
  return getProductType(product);
};

export const bodyMetadataTicketProductGenerator = (
  type,
  motiveId,
  innerState,
) => {
  const metadata = {
    ticket: {
      ...(getTitleTypeById(type) && { type: getTitleTypeById(type) }),
      ...(getTitleMotiveById(type, motiveId) && {
        motive: getTitleMotiveById(type, motiveId),
      }),
      ...(innerState?.motiveClient?.value && {
        option: innerState?.motiveClient?.value,
      }),
      origin: 'Formulario Contacto Guest',
      order: {
        ...(setProductTypeFromProductSku(innerState?.orderId?.value || '') && {
          type: setProductTypeFromProductSku(innerState?.orderId?.value || ''),
        }),
        ...(innerState?.paymentMethod?.value && {
          paymentMethod: innerState?.paymentMethod?.value,
        }),
        ...(innerState?.provider?.value && {
          provider: innerState.provider.value,
        }),
        ...(innerState?.delivery?.value && {
          delivery: innerState.delivery.value,
        }),
        ...(innerState?.fullfilment?.value && {
          fullfilment: innerState.fullfilment.value,
        }),
      },
    },
  };

  return { metadata };
};

export const getTitleMotiveById = (type, motiveId) => {
  const issue = ISSUES.find((issue) => issue.id === type);
  if (issue) {
    const motive = issue.motives.find((motive) => motive.id === motiveId);
    if (motive) {
      return motive.title;
    }
  }
  return null;
};

export const getTitleTypeById = (id) => {
  const issue = ISSUES.find((issue) => issue.id === id);
  return issue ? issue.title : null;
};

const withoutEmptyValues = (block) => {
  const entries = Object.entries(block).filter(([, value]) => {
    if (value === undefined || value === null || value === '') return false;
    if (typeof value === 'object') return Object.keys(value).length > 0;
    return true;
  });

  return Object.fromEntries(entries);
};

const optionalBlock = (name, block) => {
  const cleanBlock = withoutEmptyValues(block);

  return Object.keys(cleanBlock).length > 0 ? { [name]: cleanBlock } : {};
};

export const stateToContactParser = (innerState, motiveId, typeId) => {
  const orderId = innerState?.orderId?.value || '';

  return {
    client: {
      documentType: 'RUT',
      documentId: innerState?.rut?.value || '',
      name: innerState?.clientName?.value || '',
      email: innerState?.email?.value || '',
      phone: innerState?.phone?.value || '',
    },
    ticket: {
      type: typeId,
      motive: motiveId,
      comment: concatenateComment(motiveId, innerState),
      clientMotive: innerState?.motiveClient?.value || '',
    },
    ...optionalBlock('order', {
      oc: orderId,
      sku: innerState?.sku?.value || '',
      cud: innerState?.cud?.value || '',
      price: innerState?.value?.value || '',
      purchaseDate: innerState?.purchaseDate?.value
        ? formatDate(innerState?.purchaseDate?.value)
        : '',
      productType: setProductTypeFromProductSku(orderId),
    }),
    ...optionalBlock('payment', {
      method: innerState?.paymentMethod?.value || '',
      bank: innerState?.bank?.value || '',
      accountNumber: innerState?.accountNumber?.value || '',
    }),
    ...optionalBlock('shipping', {
      expectedDate: innerState?.expectedDate?.value
        ? formatDate(innerState?.expectedDate?.value)
        : '',
      newAddress: innerState?.newAddress?.value || '',
      cancelAddress: innerState?.cancelAddress?.value || '',
      assembly: withoutEmptyValues({
        address: innerState?.assembleAddress?.value || '',
      }),
      pickup: withoutEmptyValues({
        documentId: innerState?.pickupId?.value || '',
        name: innerState?.pickupName?.value || '',
      }),
    }),
    ...optionalBlock('extras', {
      newEmail: innerState?.newEmail?.value || '',
      commune: innerState?.commune?.value || '',
    }),
    ...bodyMetadataTicketProductGenerator(typeId, motiveId, innerState),
  };
};

export const stateContacRphone = (innerState) => {
  return {
    rut: innerState?.rut?.value || '',
    nombre_cli: innerState?.clientName?.value || '',
    telefono_mandato: innerState?.phoneMandate?.value || '',
    telefono: innerState?.phone?.value || '',
    operador: innerState?.mobileOperator?.value || '',
    cargo: innerState?.charge?.value || '',
    correo: innerState?.email?.value || '',
    comentario: innerState?.comment?.value || '',
  };
};

export const stateContactProviders = (innerState) => {
  return {
    rut: innerState?.rut?.value || '',
    nombre: innerState?.name?.value || '',
    telefono: innerState?.phone?.value || '',
    correo: innerState?.email?.value || '',
    motivo: innerState?.motive?.value || '',
    bol: innerState?.invoiceNumber?.value || '',
    comentario: innerState?.comment?.value || '',
  };
};

export const stateContactDebit = (innerState) => {
  return {
    rut: innerState?.rut?.value || '',
    nombre_cli: innerState?.nombre_cli?.value || '',
    telefono: innerState?.telefono?.value || '',
    correo: innerState?.correo?.value || '',
    oc: innerState?.oc?.value || '',
    cud: innerState?.cud?.value || '',
    banco: innerState?.bank?.value || '',
    numero_cuenta: innerState?.accountNumber?.value || '',
    rut_titular: innerState?.rutOwner?.value || '',
    nom_titular: innerState?.nameOwner?.value || '',
    direccion_anula: innerState?.cancelAddress?.value || '',
    state: innerState?.state?.value || '',
    city: innerState?.city?.value || '',
    aurisTicket: innerState?.aurisTicketId?.value || '',
  };
};

export const stateContactStore = (innerState) => {
  return {
    oc: innerState?.orderId?.value || '',
    tienda: innerState?.store?.value || '',
    letra_oc: innerState?.letterOrderId?.value || '',
    id_refund: innerState?.idRefund?.value || '',
    motivo_tienda: innerState?.motiveStore?.value || '',
    nota_credito: innerState?.creditNote?.value || '',
    telefono: innerState?.phone?.value || '',
    fecha_compra: innerState?.purchaseDate?.value
      ? formatDate(innerState?.purchaseDate?.value)
      : null,
    fecha_recepcion: innerState?.receptionDate?.value
      ? formatDate(innerState?.receptionDate?.value)
      : null,
    comentario: innerState?.comment?.value || '',
    sku: innerState?.sku?.value || '',
    des_producto: innerState?.description?.value || '',
  };
};

export const selectStateContactForms = (
  innerState,
  route,
  motiveId,
  typeId,
) => {
  let data = {};

  switch (route) {
    case RPHONE: {
      data = { form: stateContacRphone(innerState), path: '/rphone' };
      break;
    }
    case DEBIT: {
      data = { form: stateContactDebit(innerState), path: '/debitPayment' };
      break;
    }
    case PROVIDERS: {
      data = { form: stateContactProviders(innerState), path: '/providers' };
      break;
    }
    default: {
      data = {
        form: stateToContactParser(innerState, motiveId, typeId),
        images: [
          innerState?.image1,
          innerState?.image2,
          innerState?.image3,
        ].filter(Boolean),
        path: '',
      };
    }
  }
  return data;
};
